const dispatch = require("~/store.js").dispatch;

const server = require("~/server.js");

// Note that this uses some of the same events and handlers as regular audit loading.
const events = require("./auditLoadEvents.js");

const auditSummaryLoadDispatchers = {
    LoadAudit(auditTypeName, facNumber, auditID) {
        dispatch((thunkDispatch) => {
            const loading = events.Loading.New();

            thunkDispatch(loading);

            const url = `audit/${auditTypeName}/${facNumber}/${auditID}/summary`;

            server.Get(url)
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    const loaded = events.LoadedSummary.New(json);

                    thunkDispatch(loaded);
                })
                .catch((ex) => {
                    const errored = events.LoadErrored.New(ex);

                    thunkDispatch(errored);
                });
        });
    }
};

module.exports = auditSummaryLoadDispatchers;


// WEBPACK FOOTER //
// ./src/events/auditLoad/auditSummaryLoadDispatchers.js